import React, { useState, useRef, useEffect} from 'react';
import { useNavigate, NavLink, useParams  } from 'react-router-dom';
import { useForm, useFieldArray } from 'react-hook-form';
import DatosCabezaFamilia from '../DatosCabezaFamilia.jsx';
import apiService from '../../../Auth/apiService.jsx';
import AddressGenerator from './AdressGenerator.jsx';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import Months from '../../AppParametros/months.jsx';
import Years from '../../AppParametros/Years.jsx';
import MenuCaracterizacion from '../Componentes/MenuCaracterizacion';
import { useAuth } from '../../../Auth/AuthContext.jsx';
import { FaMap } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import SeguimientoCambioUbicacion from './SeguimientoCambioUbicacion';

export default function Ubicacion(){
    const hasRun = useRef(false);
    const { token, user } = useAuth();
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const { idCabezaFamilia } = useParams();
    const [show, setShow] = useState(false);
    const showModal = () => setShow(true);
    const hideModal = () => setShow(false);
    const [personas, setPersonas] = useState([]);
    const [barrios, setBarrios] = useState([]);
    const [comuna, setComuna] = useState('');
    const [zona, setZona] = useState('');
    const [asentamientos, setAsentamientos] = useState([]);
    const [asentamientosBarrio, setAsentamientosBarrio] = useState([]);
    const [tiposvivienda, setTiposvivienda] = useState([]);
    const [tipostenencia, setTipostenencia] = useState([]);
    const [formasasentamiento, setFormasasentamiento] = useState([]);
    const [porqueescogiomedellin, setPorqueescogiomedellin] = useState([]);
    const [tiposexpectativaubicacion, setTiposexpectativaubicacion] = useState([]);
    const [municipiosdto, setMunicipiosdto] = useState([]);
    const [tiposlugar, setTiposlugar] = useState([]);
    const [porquemedellinitems, setPorquemedellinitems] = useState({});
    const [Cargando, setCargando] = useState(false);
    const [FormCabezaFamilia, setFormCabezaFamilia] = useState([]);
    const [personaModalId, setPersonaModalId] = useState(null);
    const handleCloseM = () => setPersonaModalId(null);
    const handleShowM = (idPersona) => setPersonaModalId(idPersona);
    
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    const {register, handleSubmit, control, setValue, reset, watch, getValues, formState: { errors }} = useForm({
        defaultValues: {
            porquemedellinfields: [],
            personas: []
        }
      });
    const cab_formaasenid = watch('cab_formaasenid');
    const cab_tipoexpectativaubiid = watch('cab_tipoexpectativaubiid');
    const municipioubicacionid = watch('cab_municipioubicacionid');
    const { append, remove } = useFieldArray({
        control,
        name: 'porquemedellinfields'
      });
    function setDireccionPrincipal(data){
        setValue('cab_direccion', data);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        const url = '/caracterizacion/actualizarubicacion';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
               Mensaje('Guardar ubicacion', JSON.stringify(response.data));
               navigate(`/caracterizacion/grupofamiliar/${idCabezaFamilia}`);
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar ubicacion', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar ubicacion', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
          setCargando(false);
        }
      };

    const SeleccionarAsentamientos = React.useCallback(async (idBarrio) => {
        setValue('str_otrobarrionomedellin', '');
        if (!idBarrio){
            setComuna('');
            setZona('');
            setAsentamientosBarrio([]);
            setValue('cab_barrio', '');
            return;
        }
        setComuna(barrios.find(v => v.id === idBarrio)?.comComuna || '');
        setZona(barrios.find(v => v.id === idBarrio)?.zonZona || '');
        setAsentamientosBarrio(asentamientos.filter((item) => item.aseBarrioid === idBarrio)); 
    }, [barrios, asentamientos]);

    useEffect(() => {
        if (barrios.length > 0) {
            SeleccionarAsentamientos(CabezaFamiliaDatos.cab_barrio);
        }
    }, [barrios, SeleccionarAsentamientos, CabezaFamiliaDatos.cab_barrio]);
    
    const setFormValuesFromCabezaFamilia = (cabezafamilia) => {
        if (cabezafamilia) {
            reset((prevValues) => ({
                ...prevValues,
                ...cabezafamilia,
                cab_barrio: cabezafamilia.cab_barrio || "",
                cab_municipioubicacionid: cabezafamilia.cab_municipioubicacionid || "1",
                str_otrobarrionomedellin: cabezafamilia.str_otrobarrionomedellin || "",
                cab_tipoexpectativaubiid: String(cabezafamilia.cab_tipoexpectativaubiid),
                usrId: user,
                cabIdcabezafamilia: idCabezaFamilia,
            }));
            setValue('cab_formaasenid', cabezafamilia.cab_formaasenid);
            setValue('cab_porqueubicacion', cabezafamilia.cab_porqueubicacion);
        }
    };

    useEffect(() => {
        if (!hasRun.current) {
            // Helper to set array state or log error
            const setArrayStateOrError = (data, setter, label) => {
                if (Array.isArray(data)) {
                    setter(data);
                } else {
                    console.error(`Invalid data for ${label}:`, data);
                }
            };

            // Helper to handle porqueMedellin
            const handlePorqueMedellin = (cabezaporquemedellin) => {
                if (Array.isArray(cabezaporquemedellin)) {
                    for (const item of cabezaporquemedellin) {
                        setPorqueMedellin(item.cabPorquemedellinid, true);
                    }
                } else {
                    console.error('Invalid data for cabezaporquemedellin:', cabezaporquemedellin);
                }
            };

            const fetchData = async () => {
                const url = '/caracterizacion/crearformularioubicacion';
                const obj = { idCabezaFamilia: idCabezaFamilia };
                try {
                    setCargando(true);
                    const response = await apiService.post(url, obj, token);
                    const result = await response.data;
                    
                    setArrayStateOrError(result.asentamientos, setAsentamientos, 'asentamientos');
                    setArrayStateOrError(result.tiposvivienda, setTiposvivienda, 'tiposvivienda');
                    setArrayStateOrError(result.tipostenencia, setTipostenencia, 'tipostenencia');
                    setArrayStateOrError(result.formasasentamiento, setFormasasentamiento, 'formasasentamiento');
                    setArrayStateOrError(result.porqueescogiomedellin, setPorqueescogiomedellin, 'porqueescogiomedellin');
                    setArrayStateOrError(result.tiposexpectativaubicacion, setTiposexpectativaubicacion, 'tiposexpectativaubicacion');
                    setArrayStateOrError(result.municipiosdto, setMunicipiosdto, 'municipiosdto');
                    setArrayStateOrError(result.tiposlugar, setTiposlugar, 'tiposlugar');
                    handlePorqueMedellin(result.cabezaporquemedellin);
                    setArrayStateOrError(result.barrios, setBarrios, 'barrios');
                    
                    setCabezaFamiliaDatos(result.cabezafamilia);
                    setFormCabezaFamilia(result.cabezafamilia);

                } catch (error) {
                    console.error('Error fetching data:', error);
                } finally {
                    setCargando(false);
                }
            };
            fetchData();
            const fetchPersonas = async () => {
                const url = '/caracterizacion/consultarpersonasubicacion';
                const obj = {per_idpersona: idCabezaFamilia}
                try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                    setPersonas(result);
                    if (Array.isArray(result)) {
                        setValue('personas', result.map((persona) => ({
                            perIdpersona: persona.perIdpersona ?? '',
                            per_celular: persona.per_celular ?? '',
                            per_email: persona.per_email ?? '',
                            str_direccion: persona.str_direccion ?? '',
                            int_idbarrio: persona.int_idbarrio ?? ''
                        })));
                    }
                } catch (error) {
                    Mensaje('Error', error.response ? error.response.data.message : 'Error al cargar los datos');
                console.error('Error fetching data:', error);
                } finally {
                    setCargando(false);
                }
            };
        
            fetchPersonas();
            hasRun.current = true;
        }
    }, [idCabezaFamilia, setValue, user, reset, token]);
    useEffect(() => {
        if (barrios.length > 0) {
            setFormValuesFromCabezaFamilia(FormCabezaFamilia);
        }
    }, [barrios, FormCabezaFamilia]);
    const handleCheckboxFormaAsentamientoChange = (event) => {
        const { value } = event.target;
        setValue('cab_formaasenid', value)
    };
    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setPorqueMedellin(name, checked);
      };
    function setPorqueMedellin(name, checked){
        setPorquemedellinitems((prev) => ({
            ...prev,
            [name]: checked,
          }));
          if(checked){
              append(name)
          }else{
              remove(getValues('porquemedellinfields').indexOf(name));
          }
    }
    const SoloNumeros = (event) => {
        const value = event.target.value.replaceAll(/[^0-9]/g, '');
        const fieldname = event.target.name;
        setValue(fieldname, value);
    }
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const handleUppercase = (event) => {
        const uppercasedValue = event.target.value.toUpperCase();
        const fieldname = event.target.name;
        setValue(fieldname, uppercasedValue);
    };
    const handleReplicarDatosPersonas = () => {
        const {
            cab_celular = '',
            cab_direccion = '',
            cab_correoelectronico = '',
            cab_barrio = ''
        } = getValues();

        const personasForm = getValues('personas');
        if (!Array.isArray(personasForm) || personasForm.length === 0) {
            return;
        }

        personasForm.forEach((_, index) => {
            setValue(`personas.${index}.per_celular`, cab_celular, { shouldDirty: true, shouldValidate: true });
            setValue(`personas.${index}.str_direccion`, cab_direccion, { shouldDirty: true, shouldValidate: true });
            setValue(`personas.${index}.per_email`, cab_correoelectronico, { shouldDirty: true, shouldValidate: true });
            setValue(`personas.${index}.int_idbarrio`, cab_barrio, { shouldDirty: true, shouldValidate: true });
        });
    };
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Ubicaci&oacute;n del hogar</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={'/'} >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                        <li className="breadcrumb-item active"> persona</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia} />
                    <div className="row">
                    {/* left column */}
                    <div className="col-md-12">
                        <div className="card card-primary">
                        {/* /.card-header */}
                        {/* form start */}
                        <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <div className="card-body">
                            <DatosCabezaFamilia datos={CabezaFamiliaDatos} />
                            <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/>
                            <div className="card">
                                <div className="card-header">
                                <h5 className="card-title m-0">Ubicaci&oacute;n del hogar en Medell&iacute;n</h5>
                                </div>
                                <div className="card-body">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="cab_municipioubicacionid">Municipio de residencia</label>
                                            <select 
                                                {...register('cab_municipioubicacionid', 
                                                    { onChange: async (e) => {
                                                        setValue('cab_municipioubicacionid', e.target.value)
                                                        await SeleccionarAsentamientos('')
                                                    } }
                                                )} 
                                                className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {municipiosdto.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.mun_municipio} - {item.dep_departamento}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.cab_municipioubicacionid && <p style={{color: 'red'}}>Seleccione municipio</p>}
                                        </div>
                                    </div>
                                    {municipioubicacionid == '1' && <div className="col-md-3">
                                        <label htmlFor="cab_barrio">Barrio o Vereda:</label>
                                        <select 
                                            id="cab_barrio" 
                                            {...register('cab_barrio', { 
                                                onChange: async (e) => {
                                                    setValue('cab_barrio', e.target.value)
                                                    await SeleccionarAsentamientos(e.target.value)
                                                }
                                             })} 
                                            className='form-control'>
                                            <option value="">Seleccionar</option>
                                            {barrios.map((option) => (
                                            <option key={option.id} value={option.id}>
                                                {option.barBarrio}
                                            </option>
                                            ))}
                                        </select>
                                        {errors.cab_barrio && <p style={{color: 'red'}}>Seleccione barrio</p>}
                                    </div>}
                                    {(municipioubicacionid != '1') && <div className="col-md-3">
                                        <label htmlFor="str_otrobarrionomedellin">Otro barrio o vereda:</label>
                                        <input
                                            id="str_otrobarrionomedellin"
                                            className="form-control"
                                            {...register('str_otrobarrionomedellin')}
                                        />
                                    </div>
                                    }
                                </div>
                                {comuna !== '' && <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="cab_comuna">Comuna/Corregimiento:</label>
                                        <input
                                            id="cab_comuna"
                                            className="form-control"
                                            value={comuna}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="cab_zona">Zona:</label>
                                        <input
                                            id="cab_zona"
                                            className="form-control"
                                            value={zona}
                                            disabled
                                        />
                                    </div>
                                </div>}
                                <div className="row">
                                    <div className="col-md-4">
                                        <label htmlFor="cab_viveasentamiento">¿El Hogar vive o se ubica en un Asentamiento?</label>
                                        <select id="cab_viveasentamiento" {...register('cab_viveasentamiento', { required: true })} className='form-control'>
                                            <option value="">Seleccionar</option>
                                            <option value="SI">SI</option>
                                            <option value="NO">NO</option>
                                        </select>
                                        {errors.cab_viveasentamiento && <p style={{color: 'red'}}>Seleccione pregunta</p>}
                                    </div>
                                    {watch('cab_viveasentamiento') === 'SI' && <div  className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_asentamientoid">Nombre del Asentamiento</label>
                                            <select id="cab_asentamientoid" {...register('cab_asentamientoid', { validate: value => {
                                                        if (watch('cab_viveasentamiento') == 'SI' && !value) {
                                                        return 'Seleccione pregunta asentamiento';
                                                        }
                                                        return true;
                                                    }
                                                    })}
                                                    className='form-control'>
                                                <option value="">Seleccionar</option>
                                                {asentamientosBarrio.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.aseAsentamiento}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.cab_asentamientoid && <p style={{color: 'red'}}>Seleccione asentamiento</p>}
                                        </div>
                                    </div>}
                                    <div hidden className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="nuevoasentamiento">Nuevo Asentamiento:</label>
                                            <input id="nuevoasentamiento" {...register('nuevoasentamiento')}  className="form-control" placeholder="Nuevo asentamiento"/>
                                            {errors.nuevoasentamiento && <p style={{color: 'red'}}>Digite nuevo asentamiento</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_celular">Celular:</label>
                                            <input id="cab_celular" {...register('cab_celular')}  className="form-control" placeholder="Celular"/>
                                            {errors.cab_celular && <p style={{color: 'red'}}>Digite celular</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_telefono1">Tel&eacute;fono fijo:</label>
                                            <input id="cab_telefono1" {...register('cab_telefono1', { required: true })}  className="form-control" placeholder="Telefono 1"/>
                                            {errors.cab_telefono1 && <p style={{color: 'red'}}>Digite telefono</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_telefono2">Otro Tel&eacute;fono fijo/celular:</label>
                                            <input id="cab_telefono2" {...register('cab_telefono2')}  className="form-control" placeholder="Telefono 2"/>
                                            {errors.cab_telefono2 && <p style={{color: 'red'}}>Digite otro telefono</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_correoelectronico">Correo Electr&oacute;nico:</label>
                                            <input id="cab_correoelectronico" {...register('cab_correoelectronico')}  className="form-control" placeholder="Correo Electronico"/>
                                            {errors.cab_correoelectronico && <p style={{color: 'red'}}>Digite correo electronico</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="form-group" >
                                            <label htmlFor="cab_direccion">Direcci&oacute;n:</label>
                                            <div className="input-group my-colorpicker2">
                                                <input {...register('cab_direccion', { required: true })}  className="form-control" placeholder="Dirección"/>
                                                <div className="input-group-append">
                                                    <button type="button" className="input-group-text" onClick={showModal}>
                                                        <FaMap color="black" /> Generar dir. 
                                                    </button>
                                                </div>
                                            </div>
                                            {errors.cab_direccion && <p style={{color: 'red'}}>Digite direccion</p>}
                                            
                                        </div>
                                        <AddressGenerator show={show} handleClose={hideModal} setDireccion={setDireccionPrincipal}>
                                            <div>Este direccion</div>
                                        </AddressGenerator>
                                    </div>
                                    <div className="col-md-5">
                                        <div className="form-group" style={{ marginTop: '32px' }}>
                                            <Button
                                                type="button"
                                                variant="outline-primary"
                                                onClick={handleReplicarDatosPersonas}
                                                disabled={personas.length === 0}
                                            >
                                                Replicar celular, direccion, email y barrio a todas las personas
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header">
                                <h5 className="card-title m-0">Datos vivienda</h5>
                                </div>
                                <div className="card-body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_tipovivienda">Tipo Vivienda</label>
                                            <select {...register('cab_tipovivienda', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {tiposvivienda.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.tipTipovivienda}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.cab_tipovivienda && <p style={{color: 'red'}}>Seleccione tipo de vivienda</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_tipotenencia">Forma de Tenencia</label>
                                            <select {...register('cab_tipotenencia', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {tipostenencia.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.tipTenencia}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.cab_tipotenencia && <p style={{color: 'red'}}>Seleccione tipo de tenencia</p>}
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            {personas.length > 0 && personas.map((persona, index) => (
                                <div key={persona.idPersona ?? persona.per_idpersona ?? persona.id ?? index} className="card">
                                    <div className="card-header">
                                    <h5 className="card-title m-0">Datos de ubicaci&oacute;n {persona.per_nombre1} {persona.per_nombre2} {persona.per_apellido1} {persona.per_apellido2} - {persona.perIdpersona}</h5>
                                    </div>
                                    <div className="card-body">
                                        <input type="hidden" {...register(`personas.${index}.perIdpersona`)} />
                                        <div className="row">
                                            <div className="col-md-2" style={{position: 'relative', alignItems: 'center'}}>
                                                <div className="form-group" >
                                                    <label htmlFor={`per_celular-${index}`}>Celular</label>
                                                    <input id={`per_celular-${index}`} className="form-control" 
                                                        {...register(`personas.${index}.per_celular`)}
                                                        onChange={SoloNumeros}
                                                        placeholder="Celular"/>
                                                    {errors.personas?.[index]?.per_celular && <p style={{color: 'red'}}>Digite celular</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-2" style={{position: 'relative', alignItems: 'center'}}>
                                                <div className="form-group" >
                                                    <label htmlFor={`per_email-${index}`}>Email</label>
                                                    <input type='email' id={`per_email-${index}`} className="form-control" 
                                                        {...register(`personas.${index}.per_email`)}
                                                        placeholder="Email"/>
                                                    {errors.personas?.[index]?.per_email && <p style={{color: 'red'}}>Digite email</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-2" style={{position: 'relative', alignItems: 'center'}}>
                                                <div className="form-group" >
                                                    <label htmlFor={`str_direccion-${index}`}>Direcci&oacute;n</label>
                                                    <input type='text' id={`str_direccion-${index}`} className="form-control" 
                                                        {...register(`personas.${index}.str_direccion`)}
                                                        placeholder="Dirección"/>
                                                    {errors.personas?.[index]?.str_direccion && <p style={{color: 'red'}}>Digite direcci&oacute;n</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group" >
                                                    <label htmlFor={`int_idbarrio-${index}`}>Barrio</label>
                                                    <select id={`int_idbarrio-${index}`} className='form-control' {...register(`personas.${index}.int_idbarrio`)}>
                                                        <option value="">Seleccionar</option>
                                                        {barrios.map((option) => (
                                                        <option key={option.id} value={option.id}>
                                                            {option.barBarrio} - {option.comComuna} - {option.zonZona}
                                                        </option>
                                                        ))}
                                                    </select>
                                                    {errors.personas?.[index]?.int_idbarrio && <p style={{color: 'red'}}>Seleccione barrio</p>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <Button
                                                    variant="primary"
                                                    onClick={() => handleShowM(persona.perIdpersona ?? persona.idPersona ?? persona.per_idpersona ?? null)}
                                                >
                                                    Ver historial cambio ubicaci&oacute;n
                                                </Button>

                                                <Modal show={personaModalId === (persona.perIdpersona ?? persona.idPersona ?? persona.per_idpersona ?? null)} onHide={handleCloseM} size="lg">
                                                    <Modal.Header closeButton>
                                                    <Modal.Title>Historial Cambio Ubicación</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <SeguimientoCambioUbicacion idPersona={personaModalId}/>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                    <Button variant="secondary" onClick={handleCloseM}>
                                                        Cerrar
                                                    </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            <div hidden className="card">
                                <div className="card-header">
                                <h5 className="card-title m-0">Criterios de llegada a Medell&iacute;n</h5>
                                </div>
                                <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <input hidden {...register('cab_formaasenid')}/> 
                                        {formasasentamiento.map((item) => (
                                             <div key={item.id}>
                                                <label 
                                                data-tooltip-id="tooltiparriba"
                                                data-tooltip-content={item.forAyuda}>
                                                    <input
                                                    width={100}
                                                    type="radio"
                                                    name="options"
                                                    value={item.id}
                                                    checked={cab_formaasenid === item.id}
                                                    onChange={handleCheckboxFormaAsentamientoChange}
                                                    />
                                                    
                                                    {item.forForma}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <h5>Fecha de llegada a Medellìn:</h5>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_anyollegadaret">Año:</label>
                                            <select id="cab_anyollegadaret" {...register('cab_anyollegadaret')} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {Years.map((year) => (
                                                <option key={year} value={year}>
                                                    {year}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.cab_anyollegadaret && <p style={{color: 'red'}}>Seleccione año de llegada</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_mesllegadaret">Mes:</label>
                                            <select id="cab_mesllegadaret" {...register('cab_mesllegadaret')} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {Months.map((month) => (
                                                <option key={month.id} value={month.id}>
                                                    {month.name}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.cab_mesllegadaret && <p style={{color: 'red'}}>Seleccione mes de llegada</p>}
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div hidden className="card">
                                <div className="card-header">
                                <h5 className="card-title m-0">Expectativas de ubicaci&oacute;n</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row colorgray">
                                        <div className='col-md-4'>
                                            <h6>¿Porqu&eacute; eligi&oacute; venirse para Medell&iacute;n?</h6>
                                        </div>
                                        <div className="col-md-8">
                                        {porqueescogiomedellin.map((item) => (
                                            
                                                <label key={item.id} style={{padding: '10px'}}>
                                                    <input
                                                    type="checkbox"
                                                    name={item.id}
                                                    checked={porquemedellinitems[item.id] || false}
                                                    onChange={handleCheckboxChange}
                                                    />
                                                    {item.porPorquemedellin}
                                                </label>

                                            ))}
                                        
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor="cab_tipoexpectativaubiid">¿El Hogar desea?</label>
                                                <select id="cab_tipoexpectativaubiid" {...register('cab_tipoexpectativaubiid')} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {tiposexpectativaubicacion.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.tipTipoexpectativaubicacion}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.cab_tipoexpectativaubiid && <p style={{color: 'red'}}>Seleccione tipo expectativa</p>}
                                            </div>
                                        </div>
                                    </div>
                                    {(cab_tipoexpectativaubiid != '1' && cab_tipoexpectativaubiid != '5') && <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor="cab_tipoentornoid">¿A qu&eacute; lugar exacto?</label>
                                                <select {...register('cab_tipoentornoid')} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {tiposlugar.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.tipTipolugar}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.cab_tipoentornoid && <p style={{color: 'red'}}>Seleccione tipo entorno</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <div className="form-group" >
                                                <label htmlFor="cab_nombreentorno">Nombre del barrio, o de la vereda, o del corregimiento.</label>
                                                <input id="cab_nombreentorno" {...register('cab_nombreentorno')} onChange={handleUppercase} className="form-control" placeholder="Nombre entorno"/>
                                                {errors.cab_nombreentorno && <p style={{color: 'red'}}>Digite nombre entorno</p>}
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                            </div>

                            </div>
                            {/* /.card-body */}
                            <div className="card-footer">
                            {Cargando && <button type="submit" className="btn btn-primary" disabled>Guardar</button>}
                            {!Cargando && <button type="submit" className="btn btn-primary">Guardar</button>}
                            </div>
                            {/* /.card-footer */}
                        </form>
                        </div>
                        {/* /.card */}

                    </div>
                    {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" effect="solid" className="custom-tooltip" place="bottom"/>
            </section>
        </div>
    );
}